var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFreeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M36 36.0006C49.669 36.0006 60.75 29.9565 60.75 22.5006C60.75 15.0448 49.669 9.00061 36 9.00061C22.331 9.00061 11.25 15.0448 11.25 22.5006C11.25 29.9565 22.331 36.0006 36 36.0006Z",
    fill: "#F27DB4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36 36.0005C49.669 36.0005 60.75 29.9563 60.75 22.5005C60.75 15.0446 49.669 9.00049 36 9.00049C22.331 9.00049 11.25 15.0446 11.25 22.5005C11.25 29.9563 22.331 36.0005 36 36.0005Z",
    stroke: "#F27DB4",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 22.5007V36.0007C11.25 43.4539 22.3313 49.5007 36 49.5007C49.6687 49.5007 60.75 43.4539 60.75 36.0007V22.5007",
    stroke: "#F27DB4",
    strokeOpacity: 0.8,
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 36.0005V49.5005C11.25 56.9536 22.3313 63.0005 36 63.0005C49.6687 63.0005 60.75 56.9536 60.75 49.5005V36.0005",
    stroke: "url(#paint0_linear_2678_462)",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2678_462",
    x1: 36,
    y1: 36.0005,
    x2: 36,
    y2: 85.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F27DB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F27DB4",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeIcon);
export default __webpack_public_path__ + "static/media/free-icon.1c3e1c85f86f056937f053783088047f.svg";
export { ForwardRef as ReactComponent };